export const PAGE_TITLES = {
  'dealer-content': 'About Us and Current Offers',
  'finance-products': 'Investment Protection',
  'search-hub': 'Company Contact',
  'trade-walk': 'Trade-in Evaluation',
  'view-vehicle': 'Vehicle Profile',
};

export const ACTION_TITLES = {
  'dealer-content': 'About Us and Current Offers Information',
  'finance-products': 'F&I Products Information',
  'search-hub': 'Contact Information',
  'trade-walk': 'Trade-in Form',
  'view-vehicle': 'Vehicle Profiles',
};

export const ACTION_STATUS = {
  OPENED: 'opened',
  SUBMITTED: 'submitted',
};

export const ACTION_NAMES = {
  DEALER_CONTENT: 'dealer-content',
  FINANCE_PRODUCTS: 'finance-products',
  SEARCH_HUB: 'search-hub',
  TRADE_WALK: 'trade-walk',
  VIEW_VEHICLE: 'view-vehicle',
};
